import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Knob } from 'primereact/knob';
import { Chart } from 'primereact/chart';
import { InputSwitch } from "primereact/inputswitch";
import { travelService } from '../../services/extensions';



const BuTeamDashboard = () => {
    const [showDataTable, setShowDataTable] = useState(true);
    const [totalRequests, setTotalRequests] = useState(0);
    const [totalApproved, setTotalApproved] = useState(0);
    const [totalRejected, setTotalRejected] = useState(0);
    const [loading, setLoading] = useState(true); // Added loading state

    useEffect(() => {
        fetchTravelData();
    }, []);

    const fetchTravelData = () => {
        travelService.GetUserTravelcountBuWise()
            .then(response => {
                if (response.data.success) {
                    const { approvedCount, rejectCount, totalRequests } = response.data.data;
                    setTotalRequests(totalRequests || 0); // Ensure default values
                    setTotalApproved(approvedCount || 0);
                    setTotalRejected(rejectCount || 0);
                    setLoading(false); // Set loading to false when data is fetched
                }
            })
            .catch(error => {
                console.error('Error fetching travel data:', error);
                setLoading(false); // Set loading to false even if there is an error
            });
    };

    const chartData = {
        labels: ['Total Requests', 'Total Approved', 'Total Rejected'],
        datasets: [
            {
                label: 'Travel Status',  // Add label for dataset
                data: [totalRequests || 0, totalApproved || 0, totalRejected || 0], // Ensure no undefined values
                backgroundColor: ["#66BB6A", "#42A5F5", "#FFA726"],
                hoverBackgroundColor: ["#64B5F6", "#81C784", "#FFB74D"]
            }
        ]
    };
    
    const lightOptions = {
        plugins: {
            legend: {
                labels: {
                    color: '#64B5F6'
                }
            },
            tooltip: {
                callbacks: {
                    label: (context) => {
                        return `${context.dataset.label}: ${context.raw || 0}`; // Ensure tooltip has valid data
                    }
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    color: '#64B5F6'
                }
            },
            x: {
                ticks: {
                    color: '#64B5F6'
                }
            }
        }
    };
    
    return (
        <div className='col-12'>
            <div className='flex col-12 justify-content-end'>
                <span style={{ marginRight: "10px" }}> <b>Table View</b> </span>
                <InputSwitch checked={showDataTable} onChange={(e) => setShowDataTable(e.value)} /> 
                <span style={{ marginLeft: "10px" }}><b>Chart View </b></span>
            </div>

            {loading ? (
                <p>Loading data...</p> // Show loading text while data is being fetched
            ) : showDataTable ? (
                <div className='grid col-12 mt-3'>
                    <div className='grid col-6'>
                        <div className="col-6 text-center">
                            <Knob value={totalRequests} readOnly valueColor="#42A5F5" />
                            <p>Total Requests</p>
                        </div>
                        <div className="col-6 text-center">
                            <Knob value={totalApproved} readOnly valueColor="#FFA726" />
                            <p>Total Approved</p>
                        </div>
                        <div className="col-6 text-center">
                            <Knob value={totalRejected} readOnly valueColor="#FFB74D" />
                            <p>Total Rejected</p>
                        </div>
                    </div>
                    <div className="col-6 text-right">
                        <Chart type="bar" data={chartData} options={lightOptions} style={{ width: '70%', display: 'flex' }} />
                    </div>
                </div>
            ) : (
                <DataTable className="mt-4 leaves-data"
                    responsiveLayout="scroll"
                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    rows={10}
                    rowsPerPageOptions={[10, 20, 50]}
                    dataKey="id"
                    value={[{ totalRequests, totalApproved, totalRejected }]}
                    resizableColumns
                    columnResizeMode="fit"
                    scrollable="horizontal"
                    stripedRows
                    editMode="row"
                >
                    <Column field="totalRequests" header="Total Requests" />
                    <Column field="totalApproved" header="Total Approved" />
                    <Column field="totalRejected" header="Total Rejected" />
                </DataTable>
            )}
        </div>
    );
};

export default BuTeamDashboard;

